import React from 'react';
import TableWithSummary from '../../../../components/table/TableWithSummary';
import columns from './columns';
import { COUPON_USER_LIST_TABLE_EMPTY_TEXT } from '../../../../constants/service/app/couponConstants';
import {
  COUPON_USAGE_HISTORY_LIST_FILTER_OPTION_MODEL,
  COUPON_USAGE_HISTORY_LIST_SORT_OPTION_MODEL,
} from '../../../../store/modules/coupon/models';
import { LIST_PAGINATION_MODEL } from '../../../../store/modules/app/models';
import './CouponDetailUsageHistoryList.scss';

const CouponDetailUsageHistoryList = (props) => {
  const { couponUsageHistory, getList, getCouponUsageHistoryListExcelDownload, getProductSubCategoryList } = props;
  const { list, filterOption, sortOption, pagination, summary } = couponUsageHistory;

  return (
    <div className="coupon-detail-usage-history-list">
      <TableWithSummary
        data={list}
        totalCnt={summary.totalCnt}
        initialOption={{
          filterOption: COUPON_USAGE_HISTORY_LIST_FILTER_OPTION_MODEL,
          sortOption: COUPON_USAGE_HISTORY_LIST_SORT_OPTION_MODEL,
          pagination: LIST_PAGINATION_MODEL,
        }}
        isStriped={true}
        emptyText={COUPON_USER_LIST_TABLE_EMPTY_TEXT}
        showPagination
        filterOption={filterOption}
        sortOption={sortOption}
        pagination={pagination}
        getList={getList}
        getExcelDownload={getCouponUsageHistoryListExcelDownload}
        columns={(utils) =>
          columns({
            ...utils,
            getProductSubCategoryList,
          })
        }
      />
    </div>
  );
};

export default CouponDetailUsageHistoryList;
